// extracted by mini-css-extract-plugin
export default {"page":"QuestionPage_page__1i9C0","backdrop":"QuestionPage_backdrop__Q0nPn"};